module.exports = __webpack_public_path__ + "img/vocabulary-text-report-numer-bg.ae3b2ee9.png";